module.exports = __webpack_public_path__ + "img/ic_launcher_foreground.a2dd9afb.png";